export type ThankYouRedirectWindow = {
  location: { href: string };
  self: unknown;
  top: { location: { href: string } } | null;
};

function isInIframe(windowRef: ThankYouRedirectWindow): boolean {
  try {
    return windowRef.self !== windowRef.top;
  } catch {
    // If we can't safely compare, assume we're embedded.
    return true;
  }
}

export function redirectToThankYouUrl(args: {
  url: string;
  windowRef: ThankYouRedirectWindow;
  hasCustomThankYou: boolean;
}): void {
  const { url, windowRef, hasCustomThankYou } = args;

  const shouldNavigateTop = hasCustomThankYou && isInIframe(windowRef);

  if (shouldNavigateTop) {
    try {
      if (windowRef.top) {
        windowRef.top.location.href = url;
        return;
      }
    } catch {
      // Fall back to same-frame navigation.
    }
  }

  windowRef.location.href = url;
}
